import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { IepService } from "../../../../Services/IepService";
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { Message } from 'primeng/primeng';
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Router } from "@angular/router";
import { ILookupSite } from '../../../../Models/ILookupSite';
import { LookupService } from 'src/app/Services/LookupService';
import { FormESYSurveyService } from "../../../../Services/FormESYSurveyService";
import { IFormESYSurvey } from "../../../../Models/Forms/IFormESYSurvey";
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';

@Component({
  selector: 'ESYSurvey',
  templateUrl: './FormESYSurvey.component.html',
  styleUrls: ['./FormESYSurvey.component.css']
})

export class FormESYSurveyComponent extends SpinnerBase implements OnInit {

  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  panel1: boolean;
  panel2: boolean;
  panel3: boolean;
  panel4: boolean;
  panelNumber: number;
  lookupSite: any = [];
  lookupSiteName: string;
  lookupSiteAddress: string;
  lookupSiteList: ILookupSite[];
  _lookupService: LookupService;
  formESYSurveyDB: any = [];
  reportParamArray: IReportParameter[];
  schoolYearStartDate: Date;
  //public showSpinner: boolean = false;

  constructor(
    private globals: Globals, reportService: ReportService,
    iepService: IepService,
    @Inject('BASE_URL') baseUrl: string,
    public router: Router,
    lookupService: LookupService,
    private _formESYSurveyService: FormESYSurveyService) {
      super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
    this._lookupService = lookupService;
  }

  ngOnInit() {
    this.LoadFormESYSurveyDetails();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.schoolYearStartDate = new Date();
    this.successMessages = [];
    this.errorMessages = [];
    this.scrollToTop();
  }

  LoadFormESYSurveyDetails(): void {
    this._formESYSurveyService.getFormESYSurvey(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormESYSurvey) => {
        this.formESYSurveyDB = res,
        this.formESYSurveyDB.surveyDate = this.formESYSurveyDB.surveyDate == null ? null : new Date(this.formESYSurveyDB.surveyDate)
      },
        err => console.error(err)
      );
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  loadUnLock(action) {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });

  }

  //Save the conference Invitation
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;

    //update values
    this._formESYSurveyService.insertUpdateFormESYSurvey(this.formESYSurveyDB)
      .subscribe((res: IFormESYSurvey) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false
        this.LoadFormESYSurveyDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )

  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    this.LoadFormESYSurveyDetails();
  }


  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'FormInstanceID', parameterValue: this.formESYSurveyDB.formInstanceId.toString() },
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'BlankForm', parameterValue: 'False' },
      { parameterName: 'ShowWaterMark', parameterValue: 'False' },
      { parameterName: 'CustomWatermarkText', parameterValue: 'DRAFT DRAFT DRAFT' },
      { parameterName: 'isDraft', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'True' : 'False' },
      { parameterName: 'ShowCustomWaterMark', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'true' : 'false' },
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.formESYSurveyDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.formESYSurveyDB.rdlFileNameSpanish, this.reportParamArray);
  }

}
